import { Component, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import moment from 'moment';
import { Subscription, interval } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { BonusApi } from 'src/app/shared/apis/bonus.api';
import { ImgCarouselOptions } from 'src/app/shared/components/img-carousel/img-carousel-options.interface';
import { ImgCarouselComponent } from 'src/app/shared/components/img-carousel/img-carousel.component';
import { PaginatorState } from 'src/app/shared/components/paginator/paginator.module';
import { GameListItem, GameProviderParams } from 'src/app/shared/interfaces/game.interface';
import { LayoutService } from 'src/app/shared/service/layout.service';
import { LocaleService } from 'src/app/shared/service/locale.service';
import { PopupService } from 'src/app/shared/service/popup.service';
import { DailyRacesService } from '../daily-races/daily-races.service';
import { MiniGameService } from '../minigame/minigame.service';
import { LeaderBoardPopupComponent } from './../../shared/components/leader-board-popup/leader-board-popup.component';

@UntilDestroy()
@Component({
  selector: 'app-leader-board',
  templateUrl: './leader-board.component.html',
  styleUrls: ['./leader-board.component.scss'],
})
export class LeaderBoardComponent implements OnInit {
  constructor(
    private layout: LayoutService,
    private appService: AppService,
    private router: Router,
    private localeService: LocaleService,
    private bounsApi: BonusApi,
    private dialog: MatDialog,
    private popupService: PopupService,
    private ngZone: NgZone,
    private miniGameService: MiniGameService,
    private dailyRacesService: DailyRacesService,
  ) {}
  @Input() page: string = 'home';
  /** 遊戲一排顯示幾格 預設3 */
  @Input() gameColumn: number = 3;
  /** 要顯示多少遊戲數量 */
  @Input() inputPageSize: number = 12;
  /** 點擊加載更多 */
  @Input() clickLoadMore: boolean = false;
  isH5!: boolean;
  dragging!: boolean;
  open = false;
  /** 前一次裝置 */
  prevIsH5!: boolean;

  /** 静态当行 */
  racesNav: string[] = [this.localeService.getValue('race_text')];

  /** 选择显示多少条 */
  // selectedNumber: number = 5;

  /** 显示当前比赛 和 剩余时间 */
  topList: any[] = [];

  /** 列表第一排标题 */
  listFirstRow: any = [
    {
      icon: null,
      text: this.localeService.getValue('rank_a'),
    },
    {
      icon: null,
      text: this.localeService.getValue('gamer'),
    },
    {
      icon: 'icon-warning',
      text: this.localeService.getValue('race_total_bet'),
      toolTips: this.localeService.getValue('race_tips'),
    },
    {
      icon: null,
      text: this.localeService.getValue('race_reward'),
    },
  ];
  titleData: any = [
    // 0-有效流水
    {
      type: 0,
      titleArr: [
        {
          icon: null,
          text: this.localeService.getValue('rank_a'),
        },
        {
          icon: null,
          text: `${this.localeService.getValue('gamer')}, 总投注金额`,
        },
        {
          icon: null,
          text: this.localeService.getValue('race_reward'),
        },
      ],
    },
    // 10-大赢家(总输赢)
    {
      type: 10,
      titleArr: [
        {
          icon: null,
          text: this.localeService.getValue('rank_a'),
        },
        {
          icon: null,
          text: `${this.localeService.getValue('gamer')}, ${this.localeService.getValue('total_w_l')}`,
        },
        {
          icon: null,
          text: this.localeService.getValue('race_reward'),
        },
      ],
    },
    // 11-大赢家(单笔最大盈利)
    {
      type: 11,
      titleArr: [
        {
          icon: null,
          text: this.localeService.getValue('rank_a'),
        },
        {
          icon: null,
          text: `${this.localeService.getValue('gamer')}, ${this.localeService.getValue('maximum_profit_amount')}`,
        },
        {
          icon: null,
          text: this.localeService.getValue('race_reward'),
        },
      ],
    },
    // 2-运气最好
    {
      type: 2,
      titleArr: [
        {
          icon: null,
          text: this.localeService.getValue('rank_a'),
        },
        {
          icon: null,
          text: `${this.localeService.getValue('gamer')}, ${this.localeService.getValue('best_odds')}`,
        },
        {
          icon: null,
          text: this.localeService.getValue('race_reward'),
        },
      ],
    },
  ];

  /** 剩余时间 */
  remainingTime = {
    day: 0,
    hour: 0,
    min: 0,
    sec: 0,
  };
  /** 计时器订阅 */
  timerSubscription!: Subscription;
  /** 选择活动的当前下表 */
  selectedActivitIndex: number = 0;
  selectTitleData = this.titleData[this.selectedActivitIndex].titleArr;
  /** 分页器 */
  paginator: PaginatorState = {
    page: 1,
    pageSize: 21,
    total: 0,
  };
  /** 排名数据 */
  leaderBoardList: any[] = [];

  /** loading */
  rankLoading: boolean = false;
  gameLoading: boolean = false;
  selectProviders: string[] = [];
  games: any[] = [];
  showRule: boolean = false;
  @ViewChild('swiperLeaderBoard') swiperLeaderBoard?: ImgCarouselComponent;
  swiperOptions: ImgCarouselOptions = {
    loop: true,
    allowTouchMove: true,
    pagination: true,
  };
  selectedType!: number;
  /** 返回執行的type種類 */
  // 0-有效流水
  // 10-大赢家(总输赢)
  // 11-大赢家(单笔最大盈利)
  // 2-运气最好
  // 3-积分规则
  executeTypeList = [
    {
      type: 0,
      title: this.localeService.getValue('effective_flow'),
    },
    {
      type: 10,
      title: this.localeService.getValue('big_win_total'),
    },
    {
      type: 11,
      title: this.localeService.getValue('big_win_single'),
    },
    {
      type: 2,
      title: this.localeService.getValue('best_luck'),
    },
    {
      type: 3,
      title: this.localeService.getValue('points_rules'),
    },
  ];

  updatedFavoriteIds = this.miniGameService.allFavoriteIds$.pipe(untilDestroyed(this)).subscribe(ids => {
    if (!this.games) return;
    this.games.forEach((item: GameListItem) => {
      item.isFavorite = ids.includes(item.id);
    });
  });

  ngOnInit(): void {
    this.layout.isH5$.pipe(untilDestroyed(this)).subscribe(x => {
      this.isH5 = x;
      // 如果從H5變到web則會直接導首頁
      if (this.prevIsH5 && !this.isH5 && this.layout.page$.getValue() == LeaderBoardComponent) {
        this.router.navigate([this.appService.languageCode]);
      }
      this.prevIsH5 = this.isH5;
    });
    this.getTitleList();
  }

  /** 获取活动 导航列表 */
  getTitleList() {
    this.dailyRacesService.getDailyTitles().subscribe(list => {
      this.topList = list?.title || [];
      console.log('this.topList', this.topList);
      if (this.topList.length > 0) {
        this.topList.forEach(x => {
          x.type = this.executeTypeList.find(y => y.type == x.executeType)?.title;
        });
        this.selectedType = this.topList[this.selectedActivitIndex].executeType;
        this.selectTitleData = this.titleData.find((x: any) => x.type == this.selectedType).titleArr;
        // console.log('this.selectTitleData', this.selectedType);
        // console.log('this.selectTitleData', this.selectTitleData);
        this.getRank();
        this.onStartClock();
      }
    });
  }
  /** 开始倒数计时 */
  onStartClock() {
    this.timerSubscription?.unsubscribe();
    let remainingTime = this.topList[this.selectedActivitIndex].remainingTime;
    this.timerSubscription = interval(1000)
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        remainingTime -= 1000;
        if (remainingTime <= 0) this.timerSubscription?.unsubscribe();
        this.remainingTime.day = moment.duration(remainingTime).days();
        this.remainingTime.hour = moment.duration(remainingTime).hours();
        this.remainingTime.min = moment.duration(remainingTime).minutes();
        this.remainingTime.sec = moment.duration(remainingTime).seconds();
      });
  }
  toggleRule() {
    this.showRule = !this.showRule;
  }
  /** 获取所有排名 */
  getRank() {
    this.rankLoading = true;
    const params = {
      activitiesNo: this.topList[this.selectedActivitIndex]?.activitiesNo || '',
      pageIndex: 1,
      pageSize: 5, //这边请求5没用 要手动删除
    };

    this.bounsApi.getRank(params).subscribe(data => {
      this.rankLoading = false;
      if (data?.bonusInfo) {
        this.leaderBoardList = data.bonusInfo || [];
        this.leaderBoardList.splice(5, this.leaderBoardList.length);
        console.log('this.leaderBoardList', this.leaderBoardList);
      } else {
        this.leaderBoardList = [];
      }
    });
  }

  /**
   * 開啟排行榜
   */
  openLeaderBoardPopup() {
    this.popupService.open(LeaderBoardPopupComponent, {
      speed: 'faster',
      data: {
        index: this.selectedActivitIndex,
      },
    });
  }
  close() {
    this.open = false;
  }
  // 正式筛选游戏数据的请求
  getGameByProvider(init: boolean) {
    if (init) {
      this.paginator.page = 1;
      this.paginator.total = 0;
      this.paginator.pageSize = this.inputPageSize;
    }
    this.selectProviders = this.topList[this.selectedActivitIndex].providerIds;

    if (
      this.topList[this.selectedActivitIndex].providerIds.length == 0 &&
      this.topList[this.selectedActivitIndex].gameLists.length !== 0
    ) {
      this.games = [];
      this.paginator.total = this.topList[this.selectedActivitIndex].gameLists.length;
      this.paginator.pageSize = this.topList[this.selectedActivitIndex].gameLists.length;
      this.games = this.topList[this.selectedActivitIndex].gameLists;
      return;
    }
    const param: GameProviderParams = {
      labelCode: [],
      providerCatIds: this.selectProviders,
      sort: '',
      pageIndex: this.paginator.page,
      pageSize: this.paginator.pageSize,
    };
    this.gameLoading = true;
    this.miniGameService.getGameByProvider(param).subscribe(data => {
      this.gameLoading = false;
      if (data?.list?.length > 0) {
        this.paginator.total = data.total;
        if (init) {
          this.games = data.list;
        } else {
          this.games.push(...data.list);
        }
      } else {
        this.games = [];
      }
    });
    console.log('games', this.games);
  }

  openBoard() {
    this.open = !this.open;
    // this.toast.show({ message: `${this.localeService.getValue('activity_close')}`, type: 'success' });
  }

  slideChange(index: number) {
    this.ngZone.run(() => {
      this.remainingTime = {
        day: 0,
        hour: 0,
        min: 0,
        sec: 0,
      };
      this.selectedActivitIndex = index;
      this.getTitleList();
      this.getGameByProvider(true);
    });
  }
}
